module.exports = __webpack_public_path__ + "static/tinkoff-5d79b77d3b7248148697fd7865a65b1c.png";